import { createStore } from "vuex";

export default createStore({
  state: {
    eventos: [],
  },
  mutations: {},
  getters: {},
  actions: {},
  modules: {},
});
